'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:invoice-list
 * @description
 * # invoice-list
 * Directive to generate a invoice index
 */
angular.module('thothApp.directives')
.directive('invoiceList', function() {
  return {
    restrict: 'E',
    scope: {
      projectId: '='
    },
    templateUrl: 'views/invoices/_list.html',
    controller: ['$scope', 'Invoice', 'Pagination', function($scope, Invoice, Pagination) {
      $scope.invoices = {
        list: [],
        pager: {}
      };

      $scope.search = {
        'search': '',
        'by_column': ''
      };

      $scope.filters = {
        folio: 'fa-sort-asc',
        date_of_invoice: 'fa-sort',
        percentage_value: 'fa-sort',
        state: 'fa-sort'
      };

      $scope.getPage = function(page, optionalParams) {
        var params = optionalParams || {
          params: {
            page: page,
            per_page: 10,
            by_project_parent: $scope.projectId,
            by_column: $scope.search.by_column
          }
        };
        Invoice.index(params).then(function(response) {
          $scope.invoices.list = response.data.invoices;
          $scope.invoices.pager = Pagination.GetPager(
            response.data.meta.pagination.total_objects,
            page,
            response.data.meta.pagination.per_page
          );
        },function(error) {
          Invoice.error(error);
        });
      };

      $scope.getPage(1);

      $scope.filter = function(column) {
        var order = '';
        angular.forEach($scope.filters, function(value, key) {
          if(column === key) {
            if($scope.filters[key] === 'fa-sort-desc') {
              $scope.filters[key] = 'fa-sort-asc';
              order = 'ASC';
            } else {
              $scope.filters[key] = 'fa-sort-desc';
              order = 'DESC';
            }
          } else {
            $scope.filters[key] = 'fa-sort';
          }
        });
        $scope.search.by_column = {
          column: column,
          order: order
        };
        $scope.getPage(1);
      };
    }]
  };
});
